var _path, _path2, _path3, _path4, _path5, _script;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.003 845.609C298.606 881.212 340.871 909.453 387.388 928.72C433.904 947.988 483.76 957.905 534.109 957.905C584.458 957.905 634.314 947.988 680.831 928.72C727.347 909.453 769.613 881.212 805.215 845.609",
    stroke: "#FFBB0E",
    strokeWidth: 68.5844
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.526 778.093C499.117 776.69 476.97 771.6 456.004 762.916C418.61 747.426 386.648 721.196 364.161 687.542C344.056 657.452 332.331 622.635 330.074 586.668L210.441 586.293C212.737 646.036 231.52 704.071 264.826 753.916C300.44 807.217 351.06 848.76 410.285 873.291C445.819 888.01 483.492 896.208 521.526 897.711L521.526 778.093ZM546.687 897.727C563.701 897.078 580.708 895.086 597.551 891.735C660.424 879.229 718.176 848.36 763.504 803.032L679.026 718.554C650.406 747.174 613.941 766.665 574.244 774.561C565.114 776.377 555.907 777.561 546.687 778.12L546.687 897.727Z",
    fill: "#565F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.524 249.984C483.327 251.493 445.663 259.749 410.284 274.404C370.961 290.692 335.23 314.566 305.133 344.663C275.036 374.76 251.162 410.491 234.874 449.814C220.209 485.218 211.952 522.91 210.451 561.134L330.044 561.509C331.412 538.854 336.542 516.555 345.249 495.533C355.534 470.704 370.608 448.144 389.611 429.141C408.614 410.138 431.174 395.064 456.003 384.779C476.884 376.13 499.026 371.011 521.525 369.602L521.524 249.984Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.686 369.573C578.306 371.488 609.111 380.722 636.642 396.617C667.752 414.578 693.587 440.413 711.548 471.523L815.012 411.788C786.565 362.516 745.649 321.6 696.377 293.153C650.68 266.77 599.289 251.974 546.686 249.966L546.686 369.573Z",
    fill: "#565F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.686 225.621C603.605 227.672 659.228 243.624 708.664 272.166C761.735 302.807 805.806 346.877 836.447 399.949L895.843 365.656C859.182 302.159 806.454 249.43 742.956 212.77C683.093 178.208 615.648 159.076 546.686 156.999L546.686 225.621Z",
    fill: "#FFBB0E"
  })), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompete);
export default __webpack_public_path__ + "static/media/compete.2c5fc3577dc7df171f720b1d96dcb6f5.svg";
export { ForwardRef as ReactComponent };